import './App.css';
import S1_Header from "./pages/MainPage/S1_Header";
import S1_FirstSec from "./pages/MainPage/S1_FirstSec";

function App() {
  return (
    <div>
      <S1_FirstSec />
      <S1_Header />
    </div>
  );
}

export default App;
